import { render, staticRenderFns } from "./notabrasil.vue?vue&type=template&id=2b3dbafa&scoped=true"
import script from "./notabrasil.vue?vue&type=script&lang=js"
export * from "./notabrasil.vue?vue&type=script&lang=js"
import style0 from "./notabrasil.vue?vue&type=style&index=0&id=2b3dbafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3dbafa",
  null
  
)

export default component.exports